window.WendysLaborAPI = new function () {
    "use strict";

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['WendysLabor']);

    self.getDayParts = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/day_parts', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.putDayParts = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/day_parts', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getDayPartsCodes = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/day_parts/codes', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getProductivityEnhancements = function () {
        var deferred = $q.defer();
        _protected.request('productivity_enhancements', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getBrandProductivityEnhancements = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/productivity_enhancements', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.putBrandProductivityEnhancements = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/productivity_enhancements', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getSettings = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getBusinessSettings = cacheService.cache(async (brandId) => {
        const response = await _protected.request(`business/${brandId}/brands/settings`, 'GET');
        if (response?.status === 200 && response.data?.data) {
            return response.data.data;
        }
        throw response;
    })[0];

    self.putSettings = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.generateLaborForecast = function (brandId, generateData) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/generate', 'POST', generateData)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getNonServiceLaborForecasts = function (brandId, date) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/non_service_labor_forecasts', 'GET', {start_date: date})
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandLaborForecast = function (brandId, startDate, endDate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            start_week_date: startDate,
            end_week_date: endDate,
            mode: 'BASIC'
        };

        _protected.request('brands/' + brandId + '/labor_forecasts', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getServiceLaborForecasts = function (brandId, date) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/service_labor_forecasts', 'GET', {start_date: date})
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getCrewProductivitySettings = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/crew_productivity', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.putCrewProductivitySettings = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/crew_productivity', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getTransactionsProfileSettings = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/transactions_profile', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.putTransactionsProfileSettings = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/transactions_profile', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getClosedDates = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/closed_dates', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateClosedDates = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/closed_dates', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getNonServiceRulesSettings = function (brandId, params) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('settings/brands/' + brandId + '/non_service/rules', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.rules);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createNonServiceRule = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('settings/brands/' + brandId + '/non_service/rules', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
    self.updateNonServiceRule = function (brandId, ruleId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        } else if (!ruleId) {
            throw "No rule id";
        }
        _protected.request('settings/brands/' + brandId + '/non_service/rules/' + ruleId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
    self.deleteNonServiceRule = function (brandId, ruleId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        } else if (!ruleId) {
            throw "No rule id";
        }
        _protected.request('settings/brands/' + brandId + '/non_service/rules/' + ruleId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getNonServiceRules = function (brandId, params) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/non_service/rules', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.rules);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
};
